/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/password/custom-elements';

import { defineCustomElement as defineOsdsPassword } from '@ovhcloud/ods-stencil/components/password/custom-elements/osds-password.js';


export const OsdsPassword = /*@__PURE__*/ defineContainer<JSX.OsdsPassword>('osds-password', defineOsdsPassword, [
  'ariaLabel',
  'ariaLabelledby',
  'clearable',
  'color',
  'contrasted',
  'disabled',
  'error',
  'flex',
  'forbiddenValues',
  'label',
  'loading',
  'masked',
  'name',
  'placeholder',
  'readOnly',
  'required',
  'size',
  'value'
]);

